

  import React, { useEffect, useState } from 'react';
  import { Link, useLocation } from 'react-router-dom';
  import { Link as ScrollLink } from 'react-scroll';
  import './Header.css';
  import logo from '../assets/eq-logo.png';


  const Header = ({ onSearch }) => {
    const location = useLocation();
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false); // State to track menu visibility
    const isHomePage = location.pathname === "/";

    const handleScroll = () => {
      if (window.scrollY > 50) {  
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    const toggleMenu = () => {
      setMenuOpen(!menuOpen); // Toggle menu visibility
    };

    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);

    return (
      <>
        <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
          <div className="logo">
            <img src={logo} alt="EQ of AI Logo" />
          </div>
        
        {/* Hamburger icon for mobile */}
        <div className="hamburger" onClick={toggleMenu}>
            <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
            <span className={`bar ${menuOpen ? 'open' : ''}`}></span>
          </div>

          <div className={`menu-container ${menuOpen ? 'active' : ''}`}>
            <div className={`menu-items ${menuOpen ? 'active' : ''}`}>
              {isHomePage ? (
                <>
                <ScrollLink 
                  to="features" 
                  smooth={true} 
                  duration={500} 
                  offset={-70} 
                  hashSpy={true} 
                  className="menu-item" 
                  onClick={toggleMenu}
                >
                  Features
                </ScrollLink>
                <ScrollLink 
                  to="weFocusOn" 
                  smooth={true} 
                  duration={500} 
                  offset={-70} 
                  hashSpy={true} 
                  className="menu-item" 
                  onClick={toggleMenu}
                >
                  We Focus On
                </ScrollLink>
                <ScrollLink 
                  to="howWeDoIt" 
                  smooth={true} 
                  duration={500} 
                  offset={-70} 
                  hashSpy={true} 
                  className="menu-item" 
                  onClick={toggleMenu}
                >
                  How We Do It
                </ScrollLink>
                <ScrollLink 
                  to="pricing" 
                  smooth={true} 
                  duration={500} 
                  offset={-70} 
                  hashSpy={true} 
                  className="menu-item" 
                  onClick={toggleMenu}
                >
                  Pricing
                </ScrollLink>
                <ScrollLink 
                  to="footer" 
                  smooth={true} 
                  duration={500} 
                  offset={-70} 
                  hashSpy={true} 
                  className="menu-item" 
                  onClick={toggleMenu}
                >
                  About
                </ScrollLink>
              </>
            ) : (
              <>
                <Link to="/#features" className="menu-item" onClick={toggleMenu}>Features</Link>
                <Link to="/#weFocusOn" className="menu-item" onClick={toggleMenu}>We Focus On</Link>
                <Link to="/#howWeDoIt" className="menu-item" onClick={toggleMenu}>How We Do It</Link>
                <Link to="/#pricing" className="menu-item" onClick={toggleMenu}>Pricing</Link>
                <Link to="/#faq" className="menu-item" onClick={toggleMenu}>FAQ</Link>
                <Link to="/#about" className="menu-item" onClick={toggleMenu}>About</Link>
                  </>
              )}
              {/* <Link to="/About" className="menu-item" onClick={toggleMenu}>Login</Link> */}
            </div>
            <div className="right-side">
              {/* <div className="search-container">
                <input type="text" className="search-bar" placeholder="Search..." />
                <i className="fas fa-search search-icon"></i>
              </div> */}
              <Link to="https://chromewebstore.google.com/detail/eq-of-ai/camegpbfdfbonojgidllkmgiebahmged" className="get-started" target='_blank'>Get Started</Link>
            </div>  
          </div>
        </nav>
      </>
    );
  };

  export default Header;
